export { default } from "./eg_pv_table.vue";
